import React from 'react';
import { HiPhone, HiEnvelope, HiMapPin, HiUser } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';

const ContactCard = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  const isEmergency = variant === 'emergency';
  
  return (
    <div className={`${isEmergency ? 'bg-orange-50 dark:bg-orange-900/30 border-orange-400 dark:border-orange-600' : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700'} border rounded-lg p-6 shadow-sm`}>
      <h3 className={`text-xl font-bold mb-4 ${isEmergency ? 'text-orange-900 dark:text-orange-300' : 'text-gray-900 dark:text-white'}`}>
        {isEmergency ? t('home.emergencyContactTitle') : t('contact.fpraTitle')}
      </h3>
      
      <div className="space-y-3">
        <div className="flex items-start gap-3">
          <HiUser className={`h-5 w-5 mt-0.5 flex-shrink-0 ${isEmergency ? 'text-orange-600 dark:text-orange-400' : 'text-teal-600 dark:text-teal-400'}`} />
          <div>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{t('contact.contactPerson')}</p>
            <p className="text-base text-gray-900 dark:text-white">{t('contact.name')}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <HiPhone className={`h-5 w-5 mt-0.5 flex-shrink-0 ${isEmergency ? 'text-orange-600 dark:text-orange-400' : 'text-teal-600 dark:text-teal-400'}`} />
          <div>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{t('contact.phone')}</p>
            <a href="tel:+213560667120" className={`text-base ${isEmergency ? 'text-orange-700 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-300' : 'text-teal-700 dark:text-teal-400 hover:text-teal-800 dark:hover:text-teal-300'} font-medium`}>
              +213 560 66 71 20
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <HiEnvelope className={`h-5 w-5 mt-0.5 flex-shrink-0 ${isEmergency ? 'text-orange-600 dark:text-orange-400' : 'text-teal-600 dark:text-teal-400'}`} />
          <div>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{t('contact.email')}</p>
            <a href="mailto:fpra2024@gmail.com" className={`text-base ${isEmergency ? 'text-orange-700 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-300' : 'text-teal-700 dark:text-teal-400 hover:text-teal-800 dark:hover:text-teal-300'} break-all`}>
              fpra2024@gmail.com
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <HiMapPin className={`h-5 w-5 mt-0.5 flex-shrink-0 ${isEmergency ? 'text-orange-600 dark:text-orange-400' : 'text-teal-600 dark:text-teal-400'}`} />
          <div>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{t('contact.address')}</p>
            <p className="text-base text-gray-900 dark:text-white">{t('contact.addressLine')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
